import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { contactMap } from '../assets';
import FacebookColumn from './FacebookColumn';
import Responsive from './layout/Responsive';

const FooterTop = () => (
  <Background>
    <Container>
      <ShortAboutMe />
      <ContactMe />
      <FacebookColumn />
    </Container>
  </Background>
);

export default FooterTop;

const ShortAboutMe = () => (
  <ColumnContainer>
    <Title> Kort om mig </Title>
    <div>
      Svanes Dyr drives af Sabrina Svane, som er certificeret Dyreadfærdskonsulent (BSc ABT). Jeg
      specialiserer mig i løsning af problemadfærd hos henholdsvis hunde og katte og kommer gerne på
      hjemmebesøg. Mit speciale er hvalpe, aggression og stress. Jeg anvender belønningsbaserede
      træningsmetoder og tilbyder holdtræning i Nim nær Horsens for familiehunde.
    </div>
  </ColumnContainer>
);

const ContactMe = () => (
  <ColumnContainer>
    <Title> Kontakt Mig </Title>
    <ContactInfoContainer>
      <IconContainer>
        <FontAwesomeIcon icon="phone" color="#379683" size="1x" />
        <SubTitle>Telefon: </SubTitle>
        <StyledA href="tel: 93960500">93 960 500</StyledA>
      </IconContainer>
      <IconContainer>
        <FontAwesomeIcon icon="envelope" color="#379683" size="1x" />
        <SubTitle>Email: </SubTitle>
        <EmailText href="mailto:info@svanesdyr.dk">info@svanesdyr.dk</EmailText>
      </IconContainer>
      <IconContainer>
        <FontAwesomeIcon icon="map-marker-alt" color="#379683" size="1x" />
        <SubTitle>Adresse: </SubTitle>
        <div>Horsensvej 31, Nim, 8740 Brædstrup</div>
      </IconContainer>
      <IconContainer>
        <FontAwesomeIcon icon="info-circle" color="#379683" size="1x" />
        <SubTitle>CVR-nr.: </SubTitle>
        <div>35903100</div>
      </IconContainer>
    </ContactInfoContainer>
  </ColumnContainer>
);

const StyledA = styled.a`
  text-decoration: none;
  color: #fff;
`;

const Background = styled.div`
  min-height: 90px;
  background: #0f292f;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #000;
  border-top: 1px solid #000;
  color: #fff;
  padding-bottom: 25px;
  ${Responsive.media.tablet`
    padding: 0;
  `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  justify-content: space-between;
  ${Responsive.media.tablet`
    flex-direction: column;
    align-items: center;
    padding: 15px;
  `}
`;

const Title = styled.h3`
  color: #fff;
`;

const SubTitle = styled.p`
  font-weight: 600;
  color: #379683;
  margin: 0;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;

const ColumnContainer = styled.div`
  flex-direction: column;
  width: 32%;
  ${Responsive.media.tablet`
    width: 100%;
    align-self: end;
  `}
`;

const ContactInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-image: url(${contactMap});
  background-repeat: no-repeat;
  background-size: cover;
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem;
`;

const EmailText = styled.a`
  margin-left: 0.5rem;
  color: #fff;
  text-decoration: none;
`;
